/* eslint-disable new-cap */
const TokenManager = () => {
  let jwtToken = null;
  let memberId = null;

  const getToken = () => jwtToken;
  const getId = () => memberId;
  const setItems = (token, id) => {
    jwtToken = token;
    memberId = id;
    return true;
  };

  const setToken = (token) => {
    jwtToken = token;
    return true;
  };

  return {
    getToken,
    getId,
    setItems,
    setToken,
  };
};

export default TokenManager();
